import React, { useMemo } from "react";

import { Executor } from "../../../../../../../services";
import { useTypedSelector } from "../../../../../../../redux/store";
import { CellContentRoot } from "../../../../../../LightTable";
import { Row } from "..";

const ExecutorGroupCellContent: React.FC<ExecutorGroupCellContent.Props> = ({
	item,
}) => {
	const language = useTypedSelector((state) => state.session.language);

	const content = useMemo(
		() => item?.group?.name?.[language],

		[item?.group?.name, language],
	);

	return (
		<CellContentRoot
			alignItems="center"
			w="100%"
			h="100%"
			p="0"
			cursor="pointer"
		>
			<Row active={item.active} style={{ justifyContent: "center" }}>
				{content}
			</Row>
		</CellContentRoot>
	);
};

declare namespace ExecutorGroupCellContent {
	interface Props {
		item: Executor.Model;
	}
}

export default React.memo(ExecutorGroupCellContent);
